import {FileAspectType} from '../constants';
import {FileAspectTypeLabel} from '../locales';

export const getFileAspectTypeLabel = (type: FileAspectType) =>
	FileAspectTypeLabel[type];

export default getFileAspectTypeLabel;
